var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"transactions",attrs:{"fluid":""}},[_c('TransactionsTable',{attrs:{"api-url":_vm.transactionsUrl}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }